const modelMaterials = {
  wood: {
    Spruce: "SPRUCE-diffuse.png",
    Larch: "LARCH-diffuse.png",
    Oak: "OAK-diffuse.png",
    Thermowood: "THERMWOOD-diffuse.png",
    "Red Cedar (please contact before ordering)": "RED-CEDAR-diffuse.png",
  },
  linerColor: {
    Blue: "polypropalyne-blue.png",
    Grey: "polypropalyne-grey.png",
    "Light Grey": "polypropalyne-white.png"
  },
};

export default modelMaterials;
